import { useDispatch } from 'react-redux'

import { applyPromoCodeAndShowModal } from 'actions/home'
import { redirect } from 'actions/redirect'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { clickClaimDiscountBar } from 'actions/trackingKeys'

export const useGetPromoBannerDispatchedActions = () => {
  const dispatch = useDispatch()

  const dispatchApplyPromoCodeAndShowModal = () => dispatch(applyPromoCodeAndShowModal())
  const dispatchRedirect = () => dispatch(redirect('/signup/box-size'))
  const dispatchTrackUTMAndPromoCode = () => dispatch(trackUTMAndPromoCode(clickClaimDiscountBar))

  return {
    dispatchApplyPromoCodeAndShowModal,
    dispatchRedirect,
    dispatchTrackUTMAndPromoCode,
  }
}
